"use strict";

import jQuery from 'jquery';

/**
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.ui
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options
 * @param {string} options.target jQuery-Selector
 * @param {gc.gis.widget.GCWidget} options.main
 * @param {gc.gis.widget.GCWidget} options.auxiliary
 */
gc.gis.ui.GCNavbar = function(options )
{
    gc.gis.GCObservable.call( this );

    this.target    = options.target;
    this.main      = options.main;
    this.auxiliary = options.auxiliary;

    var element_target = jQuery( this.target );
    var element_container = jQuery('<div>', {
        'class': 'gc-region-container'
    });
    var element_wrapper = jQuery('<div>', {
        'class': 'gc-region-wrapper',
        html: element_container
    });
    element_target.append( element_wrapper );

    if( this.main )
    {
        element_container.append( this.main );
    }
    if( this.auxiliary )
    {
        element_container.append( this.auxiliary );
    }
};
gc.gis.ui.GCNavbar.prototype = Object.create(gc.gis.GCObservable.prototype);

gc.gis.ui.GCNavbar.prototype.getElement = function()
{
    return jQuery( this.target );
};
